import React, { useCallback, useState } from "react";
import AdminLessonPage from "./AdminLessonPage.js";
import AdminLessonPageV2 from "./AdminLessonPageV2";
import UserLessonPage from "./UserLessonPage";

// 시간표 버전 선택값 저장 키 — 새로고침/재진입 시에도 보던 버전을 유지한다.
const VERSION_KEY = "lessonPageVersion";

// ✅ Role에 따라 다른 컴포넌트 표시
function LessonPage({ user, setUser }) {
  const [useV2, setUseV2] = useState(() => localStorage.getItem(VERSION_KEY) === "v2");

  const switchVersion = useCallback(() => {
    setUseV2(prev => {
      const next = !prev;
      localStorage.setItem(VERSION_KEY, next ? "v2" : "v1");
      return next;
    });
    window.scrollTo(0, 0);
  }, []);

  // ADMIN 또는 TEACHER면 관리자 시간표 표시 (v1 기존 / v2 신규 디자인)
  if (user?.role === 'ADMIN' || user?.role === 'TEACHER') {
    const AdminPage = useV2 ? AdminLessonPageV2 : AdminLessonPage;
    return <AdminPage user={user} setUser={setUser} onSwitchVersion={switchVersion} />;
  }

  // MEMBER면 새로운 UserLessonPage 표시
  return <UserLessonPage user={user} setUser={setUser} />;
}

export default LessonPage;
